import type { IconNames } from '@gousto-internal/citrus-react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'

type LocalIconName = 'spiceHot' | 'spiceMedium' | 'spiceMild' | 'spiceNone'

type PillIconConfig =
  | {
      variant: 'citrus'
      icon: IconNames
    }
  | {
      variant: 'local'
      localIcon: LocalIconName
    }

const spiceTagTypes = ['spiceNone', 'spiceMild', 'spiceMedium', 'spiceHot'] as const

// TODO: Remove this logic once the icons are available in Citrus
const isSpiceTagType = (type?: string): type is LocalIconName =>
  spiceTagTypes.includes(type as LocalIconName)

const citrusIconByType: Partial<Record<string, IconNames>> = {
  shelfLife: 'use_by',
  dairyFree: 'dairy_free',
  glutenFree: 'gluten_free',
  vegetarian: 'vegetarian',
  vegan: 'vegan',
  plantBased: 'vegan',
  rating: 'rate_full',
  energy: 'calories',
  cookingTime: 'time',
  fiveADay: '5_a_day',
  protein: 'arrow_up',
}

export const getTagPillIcon = (
  type?: string,
  displayType?: RecipeQueryResponse['displayType'],
): PillIconConfig | null => {
  if (isSpiceTagType(type)) {
    return {
      variant: 'local',
      localIcon: type,
    }
  }

  if (type === 'cookingTime' && displayType === 'ready-to-heat') {
    return {
      variant: 'citrus',
      icon: 'microwave',
    }
  }

  const icon = type ? citrusIconByType[type] : undefined

  if (!icon) {
    return null
  }

  return {
    variant: 'citrus',
    icon,
  }
}
